/* Shopify Cart Pretty Print Template - v6.0 (final) */
      (function () {
        ////////////////////////////////////////////////////////////////
        // wait for when elements are ready in the dom
        function waitForElementExists(selector, disconnect) {
          return new Promise((resolve) => {
            if (document.querySelector(selector)) return resolve(document.querySelector(selector));
            const observer = new MutationObserver((mutations) => {
              if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                if (disconnect === true) observer.disconnect();
              }
            });
            observer.observe(document.body, { childList: true, subtree: true });
          });
        }

        let CURRENT_QUOTE_ID = '';
        let ORIGINAL_DOC_TITLE = '';
        let savedFileName = '';
        let showShareLinkAsUrl = false;
        let activeStore = '';

        // 'below' cart line item .quote-item-text-wrap
        // 'inside' cart line item .quote-item-text-wrap
        let cartOptionsPosition = 'below';// 'below' or 'inside'

        ////////////////////////////////////////////////////////////////
        ////////////////////////////////////////////////////////////////
        /* START - EMAIL DASHBOARD PROTOTYPE INTEGRATION*/

        const FORM_SELECTORS = {
          formWrapper: '.globo-form.csr--cart-quote-form',
          quoteId: '.globo-form.csr--cart-quote-form .csr--quote-id input',
          csrName: '.globo-form.csr--cart-quote-form .csr--csr-name input',
          csrEmail: '.globo-form.csr--cart-quote-form .csr--csr-email input',
          csrNote: '.globo-form.csr--cart-quote-form .csr--csr-notes textarea',
          customerName: '.globo-form.csr--cart-quote-form .csr--customer-name input',
          customerEmail: '.globo-form.csr--cart-quote-form .csr--customer-email input',
          customerPhone: '.globo-form.csr--cart-quote-form .csr--customer-phone input',
          shareLinks: '.globo-form.csr--cart-quote-form .csr--share-links textarea',
          attachFileInput: '.globo-form.csr--cart-quote-form .csr--file-attach input',
          attachFileButtonTrigger: '.globo-form.csr--cart-quote-form .csr--file-attach button.gfb__dropzone--placeholder--button',
          submitButton: '.globo-form-app .gfb__footer button[type="submit"].action',
          successMessage: '.globo-formbuilder .message.success',
        };

        const ATTACH_FILE_MAX_SIZE_MB = 30;
        const ATTACH_FILE_MAX_SIZE_BYTES = ATTACH_FILE_MAX_SIZE_MB * 1024 * 1024;
        const ATTACH_FILE_ALLOWED_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'pdf'];

        const REVIEW_FIELDS = [
          { key: 'quoteId', label: 'Quote ID', selector: FORM_SELECTORS.quoteId, required: true },
          { key: 'csrName', label: 'CSR Name', selector: FORM_SELECTORS.csrName, required: true },
          {
            key: 'csrEmail',
            label: 'CSR Email',
            selector: FORM_SELECTORS.csrEmail,
            required: true,
            validate: function (value) {
              return isValidEmail(value);
            },
          },
          { key: 'csrNote', label: 'CSR Note', selector: FORM_SELECTORS.csrNote, required: false },
          { key: 'customerName', label: 'Customer Name', selector: FORM_SELECTORS.customerName, required: true },
          {
            key: 'customerEmail',
            label: 'Customer Email',
            selector: FORM_SELECTORS.customerEmail,
            required: false,
            validate: function (value) {
              return isValidEmail(value);
            },
          },
          { key: 'customerPhone', label: 'Customer Phone', selector: FORM_SELECTORS.customerPhone, required: false },
          {
            key: 'attachFile',
            label: 'Attach File',
            selector: FORM_SELECTORS.attachFileInput,
            required: true,
            type: 'file',
            validate: function () {
              return isFileAttachValid();
            },
          },
        ];

        const REQUIRED_SELECTORS = REVIEW_FIELDS.filter(function (field) {
          return field.required === true;
        });

        const workflowSteps = [
          {
            key: 'printDialog',
            label: 'Print / Save PDF Dialog',
            hint: 'Review your print preview, and save the PDF to your computer.',
          },
          {
            key: 'fileAttached',
            label: 'Attach Saved Quote PDF',
            hint: 'You may also attach JPG, PNG, GIF, or additional PDF files. Max file size is 30MB each.',
            requiresHelpdesk: true,
          },
          {
            key: 'reviewEmailDetails',
            label: 'Review Email Details',
            hint: 'Confirm required fields and attached PDF before sending.',
            hasReviewPanel: true,
            requiresHelpdesk: true,
          },
          {
            key: 'sendQuoteEmail',
            label: 'Send Quote Email',
            hint: 'Required details are ready and confirmed.',
            requiresHelpdesk: true,
          },
        ];

        const workflowState = {
          previewOpened: false,
          sendToHelpdesk: false,
          printDialogOpened: false,
          printSaveStepSatisfied: false,
          printProceedToAttach: false,
          printReopenedNeedsAttachmentReview: false,
          manuallyOpenedStepKey: '',
          fileAttached: false,
          fileNameMatches: false,
          attachProceedToReview: false,
          reviewConfirmed: false,
          reviewConfirmAttempted: false,
          printControlAccordionsCollapsedAfterReview: false,
          sendQuoteEmail: false,
          emailSent: false,
          emailError: false,
        };

        const listEl = document.querySelector('[data-workflow-list]');
        const progressBarEl = document.querySelector('[data-progress-bar]');
        const completedCountEl = document.querySelector('[data-completed-count]');
        const totalCountEl = document.querySelector('[data-total-count]');
        const statusEl = document.querySelector('[data-workflow-status]');
        const sendToHelpdeskToggleEl = document.querySelector('[data-send-to-helpdesk-toggle]');

        if (sendToHelpdeskToggleEl) {
          sendToHelpdeskToggleEl.checked = false;
          sendToHelpdeskToggleEl.defaultChecked = false;
        }

        function getExpectedSavedFileName() {
          return savedFileName;
        }

        function getValueFromField(field) {
          const el = document.querySelector(field.selector);

          if (!el) {
            return '';
          }

          if (field.type === 'file') {
            return getAttachedFileName();
          }

          return normalizeText(el.value || '');
        }

        function getAttachedFiles() {
          const fileInput = document.querySelector(FORM_SELECTORS.attachFileInput);

          if (!fileInput) {
            return [];
          }

          if (!fileInput.files) {
            return [];
          }

          return Array.from(fileInput.files);
        }

        function getAttachedFileName() {
          const files = getAttachedFiles();

          if (files.length > 0) {
            return normalizeText(files[0].name || '');
          }

          return '';
        }

        function getAttachedFileNames() {
          return getAttachedFiles().map(function (file) {
            return normalizeText(file.name || '');
          });
        }

        function getAttachedFileExtension(file) {
          if (!file) {
            return '';
          }

          const name = String(file.name || '').toLowerCase();
          const parts = name.split('.');

          if (parts.length < 2) {
            return '';
          }

          return parts.pop();
        }

        function isAttachedFilePdf(file) {
          if (!file) {
            return false;
          }

          if (getAttachedFileExtension(file) === 'pdf') {
            return true;
          }

          return false;
        }

        function isAttachedFileAllowedType(file) {
          const extension = getAttachedFileExtension(file);

          if (ATTACH_FILE_ALLOWED_EXTENSIONS.indexOf(extension) !== -1) {
            return true;
          }

          return false;
        }

        function isAttachedFileAllowedSize(file) {
          if (!file) {
            return false;
          }

          if (file.size <= ATTACH_FILE_MAX_SIZE_BYTES) {
            return true;
          }

          return false;
        }

        function hasAttachedPdf() {
          return getAttachedFiles().some(function (file) {
            return isAttachedFilePdf(file) === true;
          });
        }

        function hasAttachedFileTypeError() {
          return getAttachedFiles().some(function (file) {
            return isAttachedFileAllowedType(file) !== true;
          });
        }

        function hasAttachedFileSizeError() {
          return getAttachedFiles().some(function (file) {
            return isAttachedFileAllowedSize(file) !== true;
          });
        }

        function isFileAttachValid() {
          const files = getAttachedFiles();

          if (files.length === 0) {
            return false;
          }

          return files.every(function (file) {
            if (isAttachedFileAllowedType(file) !== true) {
              return false;
            }

            if (isAttachedFileAllowedSize(file) !== true) {
              return false;
            }

            return true;
          });
        }

        function getAttachedPdfQuoteId() {
          const fileNames = getAttachedFileNames();

          if (fileNames.length === 0) {
            return '';
          }

          for (let i = 0; i < fileNames.length; i += 1) {
            const fileName = normalizeText(fileNames[i]);
            const match = fileName.match(/Shopping Cart Quote (QT-\d{8}-\d{6}(?:-[A-Z]{2})?)\.pdf$/i);

            if (match && match[1]) {
              return match[1].toUpperCase();
            }
          }

          return '';
        }

        function syncQuoteIdFromAttachedPdf() {
          const attachedPdfQuoteId = getAttachedPdfQuoteId();
          const quoteIdEl = document.querySelector(FORM_SELECTORS.quoteId);
          const previewQuoteIdEl = document.querySelector('[data-quote-id]');

          if (!attachedPdfQuoteId) {
            return;
          }

          CURRENT_QUOTE_ID = attachedPdfQuoteId;

          if (quoteIdEl) {
            quoteIdEl.value = attachedPdfQuoteId;
          }

          if (previewQuoteIdEl) {
            previewQuoteIdEl.textContent = attachedPdfQuoteId;
          }
        }

        function doesFileNameMatchExpected() {
          if (getAttachedPdfQuoteId()) {
            return true;
          }

          return false;
        }

        function validateReviewField(field) {
          const el = document.querySelector(field.selector);

          if (field.type === 'file') {
            if (el && el.files && el.files.length > 0) {
              return field.validate(el);
            }

            return false;
          }

          const value = getValueFromField(field);

          if (!field.required && !value) {
            return true;
          }

          if (field.validate) {
            return field.validate(value);
          }

          if (value.length > 0) {
            return true;
          }

          return false;
        }

        function validateRequiredQuoteFields() {
          let allValid = true;
          const results = {};

          if (workflowState.sendToHelpdesk !== true) {
            return {
              allValid: true,
              results: results,
            };
          }

          REVIEW_FIELDS.forEach(function (field) {
            if (field.key === 'attachFile') {
              return;
            }

            const value = getValueFromField(field);

            if (field.required !== true && !value) {
              results[field.key] = true;
              return;
            }

            const isValid = validateReviewField(field);
            results[field.key] = isValid;

            if (isValid !== true) {
              allValid = false;
            }
          });

          return { allValid: allValid, results: results };
        }

        function updatePrintControlInvalidStates(visibleWorkflowSteps, nextIndex) {
          const fieldMap = [
            {
              key: 'csrName',
              selector: '#pp-customer-rep-name',
            },
            {
              key: 'csrEmail',
              selector: '#pp-customer-rep-email',
            },
            {
              key: 'customerName',
              selector: '#pp-customer-name',
            },
            {
              key: 'customerEmail',
              selector: '#pp-customer-email',
            },
          ];

          if (isEmailSubmitStateLocked() === true) {
            return;
          }

          let isReviewStepActive = false;

          visibleWorkflowSteps.forEach(function (step, index) {
            if (step.key !== 'reviewEmailDetails') {
              return;
            }

            if (isStepActive(step) === true) {
              isReviewStepActive = true;
              return;
            }

            if (index === nextIndex) {
              isReviewStepActive = true;
            }
          });

          fieldMap.forEach(function (item) {
            const printControlEl = document.querySelector(item.selector);

            if (!printControlEl) {
              return;
            }

            printControlEl.classList.remove('is-invalid');

            if (workflowState.sendToHelpdesk !== true) {
              return;
            }

            const reviewField = REVIEW_FIELDS.find(function (field) {
              return field.key === item.key;
            });

            if (!reviewField) {
              return;
            }

            if (validateReviewField(reviewField) === true) {
              return;
            }

            if (isReviewStepActive !== true) {
              return;
            }

            if (validateReviewField(reviewField) !== true) {
              printControlEl.classList.remove('is-valid');
              printControlEl.classList.add('is-invalid');
            }
          });
        }

        function updateSinglePrintControlInvalidState(printControlEl) {
          const fieldMap = [
            {
              key: 'csrName',
              selector: '#pp-customer-rep-name',
            },
            {
              key: 'csrEmail',
              selector: '#pp-customer-rep-email',
            },
            {
              key: 'customerName',
              selector: '#pp-customer-name',
            },
            {
              key: 'customerEmail',
              selector: '#pp-customer-email',
            },
          ];

          if (!printControlEl) {
            return;
          }

          if (isEmailSubmitStateLocked() === true) {
            return;
          }

          fieldMap.forEach(function (item) {
            if (!printControlEl.matches(item.selector)) {
              return;
            }

            const reviewField = REVIEW_FIELDS.find(function (field) {
              return field.key === item.key;
            });

            if (!reviewField) {
              return;
            }

            updateSingleRenderedReviewFieldState(reviewField);

            if (validateReviewField(reviewField) === true) {
              printControlEl.classList.remove('is-invalid');
              return;
            }
            function isStepComplete(step) {
              if (step.key === 'printDialog') {
                return workflowState.printSaveStepSatisfied === true;
              }

              if (step.key === 'fileAttached') {
                if (workflowState.printReopenedNeedsAttachmentReview === true) {
                  return false;
                }

                return isFileAttachValid() === true;
              }

              if (step.key === 'reviewEmailDetails') {
                return isReviewReady() === true && workflowState.reviewConfirmed === true;
              }

              if (step.key === 'sendQuoteEmail') {
                return workflowState.emailSent === true;
              }

              return workflowState[step.key] === true;
            }
            if (workflowState.sendToHelpdesk === true) {
              printControlEl.classList.remove('is-valid');
              printControlEl.classList.add('is-invalid');
            }
          });
        }
        
        function syncReviewConfirmVisualState() {
          const confirmLabel = document.querySelector('.review-confirm');
          const confirmCheckbox = document.querySelector('[data-review-confirm-checkbox]');
          const confirmMessage = document.querySelector('.review-confirm-message');
          const badge = document.querySelector('.review-panel__badge');
          const ready = isReviewReady();

          if (!confirmLabel) {
            return;
          }

          if (ready === true) {
            confirmLabel.classList.remove('is-disabled-visual');
            confirmLabel.classList.add('is-ready');

            if (badge) {
              badge.classList.add('is-ready');
              badge.textContent = 'Ready';
            }

            if (confirmMessage) {
              confirmMessage.remove();
            }

            return;
          }

          confirmLabel.classList.remove('is-ready');
          confirmLabel.classList.add('is-disabled-visual');

          if (badge) {
            badge.classList.remove('is-ready');
            badge.textContent = 'Needs Info';
          }

          workflowState.reviewConfirmed = false;

          if (confirmCheckbox) {
            confirmCheckbox.checked = false;
          }
        }

        function updateSingleRenderedReviewFieldState(reviewField) {
          let fieldValue = '';
          let reviewFieldEl = null;
          let valueEl = null;
          let statusEl = null;
          let isValid = false;

          if (!reviewField) {
            return;
          }

          if (isEmailSubmitStateLocked() === true) {
            return;
          }

          reviewFieldEl = document.querySelector('.review-field[data-review-field-key="' + reviewField.key + '"]');

          if (!reviewFieldEl) {
            return;
          }

          valueEl = reviewFieldEl.querySelector('.review-field__value');
          statusEl = reviewFieldEl.querySelector('.review-field__status');
          isValid = validateReviewField(reviewField);
          fieldValue = getValueFromField(reviewField);

          reviewFieldEl.classList.remove('is-valid');
          reviewFieldEl.classList.remove('is-invalid');

          if (isValid === true) {
            reviewFieldEl.classList.add('is-valid');
          } else {
            reviewFieldEl.classList.add('is-invalid');
          }

          if (!fieldValue) {
            if (reviewField.required === true) {
              fieldValue = 'Missing';
            } else {
              fieldValue = 'Optional / blank';
            }
          }

          if (reviewField.key === 'attachFile' && fieldValue && isFileAttachValid() === true && hasAttachedPdf() !== true) {
            fieldValue = fieldValue + ' (PDF recommended)';
          }

          if (reviewField.key === 'attachFile' && fieldValue && isFileAttachValid() === true && hasAttachedPdf() === true && doesFileNameMatchExpected() !== true) {
            fieldValue = fieldValue + ' (missing quote ID)';
          }

          if (valueEl) {
            valueEl.textContent = fieldValue;
          }

          if (statusEl) {
            if (isValid === true) {
              statusEl.textContent = '✓';
            } else {
              statusEl.textContent = '!';
            }
          }

          syncReviewConfirmVisualState();
        }

        function updateQuotePreviewCreatedState() {
          updateRenderedWorkflowStepStates();
        }

        function isReviewReady() {
          const validation = validateRequiredQuoteFields();

          if (validation.allValid !== true) {
            return false;
          }

          if (isFileAttachValid() !== true) {
            return false;
          }

          if (hasAttachedPdf() !== true) {
            return false;
          }

          if (doesFileNameMatchExpected() !== true) {
            return false;
          }

          syncQuoteIdFromAttachedPdf();

          return true;
        }

        function canSendEmail() {
          if (workflowState.sendToHelpdesk !== true) {
            return false;
          }

          if (isReviewReady() !== true) {
            return false;
          }

          if (workflowState.reviewConfirmed !== true) {
            return false;
          }

          if (workflowState.emailSent === true) {
            return false;
          }

          return true;
        }

        function isEmailSubmitStateLocked() {
          if (workflowState.sendQuoteEmail === true) {
            return true;
          }

          if (workflowState.emailSent === true) {
            return true;
          }

          return false;
        }

        function hasBlockingPrintControlFieldValues() {
          const fieldMap = [
            {
              key: 'csrName',
              selector: '#pp-customer-rep-name',
            },
            {
              key: 'csrEmail',
              selector: '#pp-customer-rep-email',
            },
            {
              key: 'customerName',
              selector: '#pp-customer-name',
            },
            {
              key: 'customerEmail',
              selector: '#pp-customer-email',
            },
          ];

          return fieldMap.some(function (item) {
            const printControlEl = document.querySelector(item.selector);

            if (!printControlEl) {
              return false;
            }

            const reviewField = REVIEW_FIELDS.find(function (field) {
              return field.key === item.key;
            });

            if (!reviewField) {
              return false;
            }

            if (validateReviewField(reviewField) === true) {
              return false;
            }

            return true;
          });
        }

        function setPrintControlsAccordionsCollapsed(isCollapsed) {
          const detailEls = document.querySelectorAll('.print-controls details');

          detailEls.forEach(function (detailEl) {
            if (isCollapsed === true) {
              detailEl.removeAttribute('open');
              return;
            }

            detailEl.setAttribute('open', '');
          });
        }

        function collapsePrintControlAccordionsAfterReviewComplete() {
          if (workflowState.sendToHelpdesk !== true) {
            return;
          }

          if (workflowState.printControlAccordionsCollapsedAfterReview === true) {
            return;
          }

          if (isReviewReady() !== true) {
            return;
          }

          workflowState.printControlAccordionsCollapsedAfterReview = true;
          setPrintControlsAccordionsCollapsed(true);
        }

        function openInvalidPrintControlAccordions() {
          const fieldMap = [
            {
              key: 'csrName',
              selector: '#pp-customer-rep-name',
            },
            {
              key: 'csrEmail',
              selector: '#pp-customer-rep-email',
            },
            {
              key: 'customerName',
              selector: '#pp-customer-name',
            },
            {
              key: 'customerEmail',
              selector: '#pp-customer-email',
            },
          ];

          if (workflowState.sendToHelpdesk !== true) {
            return;
          }

          fieldMap.forEach(function (item) {
            const printControlEl = document.querySelector(item.selector);

            if (!printControlEl) {
              return;
            }

            const reviewField = REVIEW_FIELDS.find(function (field) {
              return field.key === item.key;
            });

            if (!reviewField) {
              return;
            }

            if (validateReviewField(reviewField) === true) {
              return;
            }

            const detailEl = printControlEl.closest('.print-controls details');

            if (!detailEl) {
              return;
            }

            detailEl.setAttribute('open', '');
          });
        }

        function getReviewFieldFocusTarget(fieldKey) {
          if (fieldKey === 'csrName') {
            return document.querySelector('#pp-customer-rep-name');
          }

          if (fieldKey === 'csrEmail') {
            return document.querySelector('#pp-customer-rep-email');
          }

          if (fieldKey === 'csrNote') {
            return document.querySelector('#pp-notes');
          }

          if (fieldKey === 'customerName') {
            return document.querySelector('#pp-customer-name');
          }

          if (fieldKey === 'customerEmail') {
            return document.querySelector('#pp-customer-email');
          }

          if (fieldKey === 'customerPhone') {
            return document.querySelector('#pp-customer-phone');
          }

          if (fieldKey === 'attachFile') {
            return document.querySelector('[data-attach-pdf-trigger]');
          }

          return null;
        }

        function focusReviewFieldTarget(fieldKey) {
          const targetEl = getReviewFieldFocusTarget(fieldKey);

          if (!targetEl) {
            return;
          }

          const detailEl = targetEl.closest('.print-controls details');

          if (detailEl) {
            detailEl.setAttribute('open', '');
          }

          window.setTimeout(function () {
            targetEl.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
              inline: 'nearest',
            });

            window.setTimeout(function () {
              if (typeof targetEl.focus === 'function') {
                targetEl.focus({
                  preventScroll: true,
                });
              }
            }, 260);
          }, 0);
        }

        function isStepComplete(step) {
          if (step.key === 'printDialog') {
            if (workflowState.sendToHelpdesk === true) {
              return workflowState.printSaveStepSatisfied === true && workflowState.printProceedToAttach === true;
            }

            return workflowState.printSaveStepSatisfied === true;
          }

          if (step.key === 'fileAttached') {
            if (isEmailSubmitStateLocked() === true) {
              return true;
            }

            if (workflowState.printReopenedNeedsAttachmentReview === true) {
              return false;
            }

            return isFileAttachValid() === true && workflowState.attachProceedToReview === true;
          }

          if (step.key === 'reviewEmailDetails') {
            if (isEmailSubmitStateLocked() === true) {
              return true;
            }

            return isReviewReady() === true && workflowState.reviewConfirmed === true;
          }

          if (step.key === 'sendQuoteEmail') {
            return workflowState.emailSent === true;
          }

          return workflowState[step.key] === true;
        }

        function isStepActive(step) {
          if (step.key === 'printDialog') {
            if (workflowState.printSaveStepSatisfied !== true) {
              return true;
            }

            if (workflowState.sendToHelpdesk === true && workflowState.printProceedToAttach !== true) {
              return true;
            }
          }

          if (step.key === 'fileAttached') {
            if (isEmailSubmitStateLocked() === true) {
              return false;
            }

            if (workflowState.printSaveStepSatisfied === true && workflowState.printProceedToAttach === true && workflowState.printReopenedNeedsAttachmentReview === true) {
              return true;
            }

            if (workflowState.printSaveStepSatisfied === true && workflowState.printProceedToAttach === true && workflowState.attachProceedToReview !== true) {
              return true;
            }
          }

          if (step.key === 'reviewEmailDetails') {
            if (isEmailSubmitStateLocked() === true) {
              return false;
            }

            if (workflowState.printReopenedNeedsAttachmentReview === true) {
              return false;
            }

            if (workflowState.attachProceedToReview === true && isReviewReady() === true && workflowState.reviewConfirmed !== true) {
              return true;
            }
          }

          if (step.key === 'sendQuoteEmail') {
            if (canSendEmail() === true) {
              return true;
            }

            if (workflowState.sendQuoteEmail === true && workflowState.emailSent !== true) {
              return true;
            }
          }

          return false;
        }

        function isStepError(step) {
          if (step.key === 'fileAttached') {
            if (isEmailSubmitStateLocked() === true) {
              return false;
            }

            if (workflowState.fileAttached === true && isFileAttachValid() !== true) {
              return true;
            }
          }

          if (step.key === 'sendQuoteEmail') {
            return workflowState.emailError === true;
          }

          return false;
        }

        function getStepLabel(step) {
          if (step.key === 'printDialog') {
            return 'Print / Save PDF Dialog';
          }

          if (step.key === 'fileAttached') {
            if (isEmailSubmitStateLocked() === true) {
              return 'Quote Files Attached';
            }

            if (isFileAttachValid() === true && hasAttachedPdf() === true) {
              return 'Quote Files Attached';
            }

            if (isFileAttachValid() === true && hasAttachedPdf() !== true) {
              return 'Files attached, PDF recommended';
            }

            return 'Attach Saved Quote PDF';
          }

          if (step.key === 'reviewEmailDetails') {
            if (isEmailSubmitStateLocked() === true) {
              return 'Email Details Reviewed';
            }

            if (isReviewReady() === true && workflowState.reviewConfirmed === true) {
              return 'Email Details Reviewed';
            }

            return 'Review Email Details';
          }

          if (step.key === 'sendQuoteEmail') {
            if (workflowState.emailSent === true) {
              return 'Email Sent';
            }

            if (workflowState.sendQuoteEmail === true) {
              return 'Send Quote Email Submitted';
            }

            return 'Send Quote Email';
          }

          return step.label;
        }

        function getStepHint(step) {
          if (step.key === 'printDialog') {
            if (workflowState.printSaveStepSatisfied === true) {
              if (workflowState.sendToHelpdesk === true) {
                return 'Print attempt logged. Next, attach the saved PDF.';
              }

              return 'Print attempt logged.';
            }

            return step.hint;
          }

          if (step.key === 'fileAttached') {
            const fileName = getAttachedFileName();

            if (isEmailSubmitStateLocked() === true) {
              return 'Quote file was submitted with the email.';
            }

            if (workflowState.printReopenedNeedsAttachmentReview === true && fileName) {
              return 'You opened Print / Save PDF again. Continue with the currently attached PDF, or replace it with the newly saved PDF.';
            }

            if (workflowState.fileAttached === true && hasAttachedFileSizeError() === true) {
              return 'Max file size is 30MB.';
            }

            if (workflowState.fileAttached === true && hasAttachedFileTypeError() === true) {
              return 'Allowed file types: JPG, JPEG, PNG, GIF, and PDF.';
            }

            if (isFileAttachValid() === true && hasAttachedPdf() !== true) {
              return 'No PDF detected. Images are allowed, but the saved cart quote PDF should normally be attached before sending.';
            }

            if (isFileAttachValid() === true && hasAttachedPdf() === true && doesFileNameMatchExpected() !== true) {
              return 'PDF attached, but the filename must include "Shopping Cart Quote QT-" plus the quote date/time ID.';
            }

            if (isFileAttachValid() === true) {
              return fileName;
            }

            return step.hint;
          }

          if (step.key === 'reviewEmailDetails') {
            if (isEmailSubmitStateLocked() === true) {
              return 'Required details were submitted with the email.';
            }

            if (isReviewReady() !== true) {
              return 'Complete required fields before confirming.';
            }

            if (workflowState.reviewConfirmed !== true) {
              return 'Confirm the details and attachment are correct.';
            }

            return 'Confirmed. Send quote email is unlocked.';
          }

          if (step.key === 'sendQuoteEmail') {
            if (workflowState.emailSent === true) {
              return 'Quote email sent. Start a new quote when ready.';
            }

            if (workflowState.sendQuoteEmail === true && workflowState.emailSent !== true) {
              return 'Waiting for success confirmation.';
            }

            if (canSendEmail() !== true && workflowState.sendQuoteEmail !== true) {
              return 'Disabled until review confirmation is checked.';
            }

            return step.hint;
          }

          return step.hint;
        }

        function getVisibleWorkflowSteps() {
          return workflowSteps.filter(function (step) {
            if (step.requiresHelpdesk === true && workflowState.sendToHelpdesk !== true) {
              return false;
            }

            return true;
          });
        }

        function getCompletedCount() {
          let count = 0;
          const visibleWorkflowSteps = getVisibleWorkflowSteps();

          visibleWorkflowSteps.forEach(function (step) {
            if (isStepComplete(step) === true) {
              count += 1;
            }
          });

          return count;
        }

        function getNextIncompleteIndex() {
          const visibleWorkflowSteps = getVisibleWorkflowSteps();

          for (let i = 0; i < visibleWorkflowSteps.length; i += 1) {
            if (isStepComplete(visibleWorkflowSteps[i]) !== true) {
              return i;
            }
          }

          return -1;
        }

        function getCartItemShareLink(row) {
          if (!row) {
            return '';
          }

          const shareLinkEl = row.querySelector('.cart-custom-options .cart-share-link[title="Click to Edit Your Options"]');

          if (shareLinkEl && shareLinkEl.href) {
            return shareLinkEl.href;
          }

          const fallbackShareLinkEl = row.querySelector('.cart-custom-options .cart-share-link');

          if (fallbackShareLinkEl && fallbackShareLinkEl.href) {
            return fallbackShareLinkEl.href;
          }

          return '';
        }

        function buildCartShareLinksText() {
          const cartRoot = getCartRoot();
          const rows = cartRoot ? cartRoot.querySelectorAll('.cart-item') : [];
          const blocks = [];

          rows.forEach(function (row, index) {
            const titleEl = row.querySelector('.cart-item__title');
            const title = getTextContent(titleEl);
            const qty = extractQuantity(row);
            const shareLink = getCartItemShareLink(row);

            if (!shareLink) {
              return;
            }

            let heading = String(index + 1) + '. ';

            if (title) {
              heading += title;
            } else {
              heading += 'Cart Item';
            }

            if (qty) {
              heading += ' (Qty: ' + qty + ')';
            }

            blocks.push(heading + '\n' + shareLink);
          });

          return blocks.join('\n\n');
        }

        function syncEmailFormFields(skipWorkflowRender) {
          const quoteIdEl = document.querySelector(FORM_SELECTORS.quoteId);
          const csrNameEl = document.querySelector(FORM_SELECTORS.csrName);
          const csrEmailEl = document.querySelector(FORM_SELECTORS.csrEmail);
          const csrNoteEl = document.querySelector(FORM_SELECTORS.csrNote);
          const customerNameEl = document.querySelector(FORM_SELECTORS.customerName);
          const customerEmailEl = document.querySelector(FORM_SELECTORS.customerEmail);
          const customerPhoneEl = document.querySelector(FORM_SELECTORS.customerPhone);
          const shareLinksEl = document.querySelector(FORM_SELECTORS.shareLinks);

          if (quoteIdEl) {
            const attachedPdfQuoteId = getAttachedPdfQuoteId();

            if (attachedPdfQuoteId) {
              quoteIdEl.value = attachedPdfQuoteId;
            } else {
              quoteIdEl.value = buildQuoteId();
            }
          }

          if (csrNameEl) {
            csrNameEl.value = document.querySelector('#pp-customer-rep-name').value;
          }

          if (csrEmailEl) {
            csrEmailEl.value = document.querySelector('#pp-customer-rep-email').value;
          }

          if (csrNoteEl) {
            csrNoteEl.value = document.querySelector('#pp-notes').value;
          }

          if (customerNameEl) {
            customerNameEl.value = document.querySelector('#pp-customer-name').value;
          }

          if (customerEmailEl) {
            customerEmailEl.value = document.querySelector('#pp-customer-email').value;
          }

          if (customerPhoneEl) {
            customerPhoneEl.value = document.querySelector('#pp-customer-phone').value;
          }

          if (shareLinksEl) {
            shareLinksEl.value = buildCartShareLinksText();
          }

          workflowState.reviewConfirmed = false;

          if (skipWorkflowRender === true) {
            return;
          }

          renderWorkflow();
        }

        function logPrintPreviewOpened() {
          const hadCompletedPrintStep = workflowState.printSaveStepSatisfied === true;
          const hadAttachedFile = isFileAttachValid() === true;

          workflowState.previewOpened = true;
          workflowState.printDialogOpened = true;

          if (workflowState.sendToHelpdesk === true && hadCompletedPrintStep === true) {
            workflowState.printSaveStepSatisfied = false;
            workflowState.printProceedToAttach = false;
            workflowState.attachProceedToReview = false;
            workflowState.reviewConfirmed = false;
            workflowState.sendQuoteEmail = false;
            workflowState.emailSent = false;
            workflowState.emailError = false;

            if (hadAttachedFile === true) {
              workflowState.printReopenedNeedsAttachmentReview = true;
            }
          }

          console.log('print preview opened: no workflow steps completed.');
          renderWorkflow();
        }

        function markPrintAttempted() {
          workflowState.previewOpened = true;
          workflowState.printDialogOpened = true;
          workflowState.printSaveStepSatisfied = true;
          workflowState.printProceedToAttach = false;
          workflowState.attachProceedToReview = false;
          workflowState.reviewConfirmed = false;
          console.log('beforeprint fired: user attempted to print / save PDF.');
          renderWorkflow();
        }

        function continueFromPrintToAttach() {
          if (workflowState.printSaveStepSatisfied !== true) {
            return;
          }

          workflowState.printProceedToAttach = true;
          workflowState.manuallyOpenedStepKey = '';
          workflowState.attachProceedToReview = false;
          workflowState.reviewConfirmed = false;
          workflowState.sendQuoteEmail = false;
          workflowState.emailSent = false;
          workflowState.emailError = false;

          renderWorkflow();
        }

        function isEmailSuccessMessageVisible() {
          const successMessageEl = document.querySelector(FORM_SELECTORS.successMessage);

          if (!successMessageEl) {
            return false;
          }

          const computedStyle = window.getComputedStyle(successMessageEl);

          if (computedStyle.display === 'none') {
            return false;
          }

          if (computedStyle.visibility === 'hidden') {
            return false;
          }

          return true;
        }

        function markEmailSentFromSuccess() {
          if (workflowState.emailSent === true) {
            return;
          }

          workflowState.fileAttached = true;
          workflowState.fileNameMatches = true;
          workflowState.reviewConfirmed = true;
          workflowState.reviewConfirmAttempted = false;
          workflowState.printReopenedNeedsAttachmentReview = false;
          workflowState.manuallyOpenedStepKey = '';
          workflowState.sendQuoteEmail = true;
          workflowState.emailSent = true;
          workflowState.emailError = false;
          updateSendEmailPanelState();
          updateRenderedWorkflowStepStates();
        }

        function checkEmailSentSuccessState() {
          if (isEmailSuccessMessageVisible() === true) {
            markEmailSentFromSuccess();
          }
        }

        function installEmailSuccessMessageObserver() {
          const successMessageEl = document.querySelector(FORM_SELECTORS.successMessage);

          if (!successMessageEl) {
            return;
          }

          if (successMessageEl.__quoteEmailSuccessObserverInstalled === true) {
            return;
          }

          successMessageEl.__quoteEmailSuccessObserverInstalled = true;

          const observer = new MutationObserver(function () {
            checkEmailSentSuccessState();
          });

          observer.observe(successMessageEl, {
            attributes: true,
            attributeFilter: ['style', 'class'],
            childList: true,
            subtree: true,
          });

          checkEmailSentSuccessState();
        }

        function installPowerfulFormAjaxSuccessDetector() {
          if (window.__quoteEmailPowerfulFormAjaxDetectorInstalled === true) {
            return;
          }

          window.__quoteEmailPowerfulFormAjaxDetectorInstalled = true;

          if (window.fetch) {
            const originalFetch = window.fetch;

            window.fetch = function () {
              return originalFetch.apply(this, arguments).then(function (response) {
                const responseUrl = String(response.url || '');

                if (responseUrl.indexOf('https://app.powerfulform.com') !== -1) {
                  response
                    .clone()
                    .json()
                    .then(function (data) {
                      if (!data) {
                        return;
                      }

                      if (data.success === true || data.success === 'true') {
                        markEmailSentFromSuccess();
                      }
                    })
                    .catch(function () {});
                }

                return response;
              });
            };
          }

          if (window.XMLHttpRequest) {
            const originalOpen = window.XMLHttpRequest.prototype.open;
            const originalSend = window.XMLHttpRequest.prototype.send;

            window.XMLHttpRequest.prototype.open = function (method, url) {
              this.__quoteEmailRequestUrl = String(url || '');
              return originalOpen.apply(this, arguments);
            };

            window.XMLHttpRequest.prototype.send = function () {
              this.addEventListener('load', function () {
                if (!this.__quoteEmailRequestUrl) {
                  return;
                }

                if (this.__quoteEmailRequestUrl.indexOf('https://app.powerfulform.com') === -1) {
                  return;
                }

                try {
                  const data = JSON.parse(this.responseText);

                  if (data.success === true || data.success === 'true') {
                    markEmailSentFromSuccess();
                  }
                } catch (error) {}
              });

              return originalSend.apply(this, arguments);
            };
          }
        }

        function submitEmail() {
          if (canSendEmail() !== true) {
            renderWorkflow();
            return;
          }

          workflowState.sendQuoteEmail = true;
          workflowState.emailError = false;
          updateSendEmailPanelState();

          installEmailSuccessMessageObserver();
          installPowerfulFormAjaxSuccessDetector();

          if (document.body.classList.contains('demo')) {
            window.setTimeout(function () {
              const successMessageEl = document.querySelector(FORM_SELECTORS.successMessage);

              if (successMessageEl) {
                successMessageEl.style.display = 'block';
              }

              checkEmailSentSuccessState();
            }, 900);

            return;
          }

          const submitButton = document.querySelector(FORM_SELECTORS.submitButton);

          if (submitButton) {
            submitButton.click();
          }
        }

        function resetWorkflowStateForNewQuote() {
          const sendToHelpdeskToggle = document.querySelector('[data-send-to-helpdesk-toggle]');
          const customerNamePrintEl = document.querySelector('#pp-customer-name');
          const customerEmailPrintEl = document.querySelector('#pp-customer-email');
          const customerPhonePrintEl = document.querySelector('#pp-customer-phone');
          const notesPrintEl = document.querySelector('#pp-notes');
          const fileInput = document.querySelector(FORM_SELECTORS.attachFileInput);
          const successMessageEl = document.querySelector(FORM_SELECTORS.successMessage);

          workflowState.previewOpened = false;
          workflowState.sendToHelpdesk = false;
          workflowState.printDialogOpened = false;
          workflowState.printSaveStepSatisfied = false;
          workflowState.printProceedToAttach = false;
          workflowState.printReopenedNeedsAttachmentReview = false;
          workflowState.manuallyOpenedStepKey = '';
          workflowState.fileAttached = false;
          workflowState.fileNameMatches = false;
          workflowState.attachProceedToReview = false;
          workflowState.reviewConfirmed = false;
          workflowState.reviewConfirmAttempted = false;
          workflowState.sendQuoteEmail = false;
          workflowState.emailSent = false;
          workflowState.emailError = false;

          CURRENT_QUOTE_ID = '';
          savedFileName = '';

          // important - Needs method to set modal fields and globo form field values to empty for rest
          // Keep CSR name/email filled so CSR does not need to repopulate them for every quote.
          if (customerNamePrintEl) {
            customerNamePrintEl.value = '';
          }

          if (customerEmailPrintEl) {
            customerEmailPrintEl.value = '';
          }

          if (customerPhonePrintEl) {
            customerPhonePrintEl.value = '';
          }

          if (notesPrintEl) {
            notesPrintEl.value = '';
          }

          if (sendToHelpdeskToggle) {
            sendToHelpdeskToggle.checked = false;
            sendToHelpdeskToggle.defaultChecked = false;
          }

          if (fileInput) {
            fileInput.value = '';
          }

          if (successMessageEl) {
            successMessageEl.style.display = 'none';
          }

          document.querySelectorAll('.print-controls .is-invalid, .print-controls .is-valid').forEach(function (fieldEl) {
            fieldEl.classList.remove('is-invalid');
            fieldEl.classList.remove('is-valid');
          });

          syncEmailFormFields();
          renderPrettyPrintPreview();
          renderWorkflow();
        }

        function resetWorkflowAfterAttachedFilesChange() {
          if (isEmailSubmitStateLocked() === true) {
            return;
          }

          workflowState.fileAttached = getAttachedFiles().length > 0;
          workflowState.fileNameMatches = doesFileNameMatchExpected();
          syncQuoteIdFromAttachedPdf();
          syncEmailFormFields(true);
          workflowState.printReopenedNeedsAttachmentReview = false;
          workflowState.manuallyOpenedStepKey = '';
          workflowState.attachProceedToReview = false;
          workflowState.reviewConfirmed = false;
          workflowState.sendQuoteEmail = false;
          workflowState.emailSent = false;
          workflowState.emailError = false;
        }

        function clearAttachedFiles() {
          const fileInput = document.querySelector(FORM_SELECTORS.attachFileInput);

          if (fileInput) {
            fileInput.value = '';
          }

          resetWorkflowAfterAttachedFilesChange();
          renderWorkflow();
        }

        function continueToReviewWithCurrentAttachedFiles() {
          if (isFileAttachValid() !== true) {
            return;
          }

          workflowState.fileAttached = getAttachedFiles().length > 0;
          workflowState.fileNameMatches = doesFileNameMatchExpected();
          syncQuoteIdFromAttachedPdf();
          workflowState.printReopenedNeedsAttachmentReview = false;
          workflowState.manuallyOpenedStepKey = '';
          workflowState.attachProceedToReview = true;
          workflowState.reviewConfirmed = false;
          workflowState.sendQuoteEmail = false;
          workflowState.emailSent = false;
          workflowState.emailError = false;

          renderWorkflow();
        }

        function removeAttachedFileAtIndex(removeIndex) {
          const fileInput = document.querySelector(FORM_SELECTORS.attachFileInput);

          if (!fileInput) {
            return;
          }

          if (!fileInput.files) {
            return;
          }

          if (fileInput.files.length <= 1) {
            fileInput.value = '';
            resetWorkflowAfterAttachedFilesChange();
            renderWorkflow();
            return;
          }

          try {
            const transfer = new DataTransfer();

            Array.from(fileInput.files).forEach(function (file, index) {
              if (index !== removeIndex) {
                transfer.items.add(file);
              }
            });

            fileInput.files = transfer.files;
          } catch (error) {
            fileInput.value = '';
          }

          resetWorkflowAfterAttachedFilesChange();
          renderWorkflow();
        }

        function createPrintDialogPanel() {
          const printPanel = document.createElement('div');
          const actions = document.createElement('div');
          const printButton = document.createElement('button');
          const forceBreakButton = document.createElement('button');

          printPanel.className = 'review-panel quote-print-panel';
          actions.className = 'quote-print-panel__actions';

          printButton.className = 'open-print-preview btn workflow-action'; //workflow-action-btn workflow-action--primary
          printButton.type = 'button';
          printButton.setAttribute('title', 'Open Print / Save PDF Dialog');
          printButton.textContent = 'Open Print / Save PDF Dialog';

          forceBreakButton.className = 'force-break-print-preview preview-section__force-page-break workflow-action';
          forceBreakButton.type = 'button';
          //forceBreakButton.setAttribute('title', 'Force Page Breaks for Printed PDF');
          forceBreakButton.setAttribute('data-force-page-breaks-toggle', '');
          forceBreakButton.innerHTML = `
            <svg id="svg-force-page-break" fill="#000000" width="24px" height="24px" viewBox="0 0 24 24">
              <title>Force Page Breaks for Printed PDF</title>
              <path class="svg-page-break-1" d="M3,12H7m14,0H17m-6,0h2"></path>
              <path class="svg-page-break-2" d="M5,8V4A1,1,0,0,1,6,3H17l2,2V8"></path>
              <path class="svg-page-break-3" data-name="primary" d="M5,16v4a1,1,0,0,0,1,1H18a1,1,0,0,0,1-1V16"></path>
              <polygon class="svg-page-break-4" data-name="primary" points="17 3 17 5 19 5 17 3"></polygon>
            </svg>
             <svg id="svg-remove-page-break" fill="#000000" width="24px" height="24px" viewBox="0 0 24 24">
              <title>Remove Page Breaks for Digital PDF</title>
                <path class="svg-page-break-2" d="M5,16V4A1,1,0,0,1,6,3H17l2,2V16"></path>
                <path class="svg-page-break-3" data-name="primary" d="M5,16v4a1,1,0,0,0,1,1H18a1,1,0,0,0,1-1V16"></path>
                <polygon class="svg-page-break-4" data-name="primary" points="17 3 17 5 19 5 17 3"></polygon>
              </svg>
          `;

          actions.appendChild(printButton);
          actions.appendChild(forceBreakButton);
          printPanel.appendChild(actions);

          if (workflowState.printSaveStepSatisfied === true) {
            const proceedButton = document.createElement('button');

            proceedButton.className = 'btn workflow-action workflow-action--primary';
            proceedButton.type = 'button';
            proceedButton.setAttribute('data-proceed-print-to-attach', '');
            proceedButton.textContent = 'Continue to Attach';

            printPanel.appendChild(proceedButton);
          }

          return printPanel;
        }

        function createReviewPanel() {
          const panel = document.createElement('div');
          const title = document.createElement('p');
          const titleText = document.createElement('span');
          const badge = document.createElement('span');
          const list = document.createElement('ul');
          const confirmLabel = document.createElement('label');
          const confirmCheckbox = document.createElement('input');
          const confirmText = document.createElement('span');
          const confirmMessage = document.createElement('p');
          const ready = isReviewReady();

          panel.className = 'review-panel';
          title.className = 'review-panel__title';
          titleText.textContent = 'Review Email Details';
          badge.className = 'review-panel__badge';

          if (ready === true) {
            badge.classList.add('is-ready');
            badge.textContent = 'Ready';
          } else {
            badge.textContent = 'Needs Info';
          }

          title.appendChild(titleText);
          title.appendChild(badge);
          list.className = 'review-field-list';

          REVIEW_FIELDS.forEach(function (field) {
            const item = document.createElement('li');
            const label = document.createElement('span');
            const value = document.createElement('span');
            const status = document.createElement('span');
            const isValid = validateReviewField(field);
            let fieldValue = getValueFromField(field);

            item.className = 'review-field';
            item.setAttribute('data-review-field-key', field.key);
            item.setAttribute('role', 'button');
            item.setAttribute('tabindex', '0');

            if (isValid === true) {
              item.classList.add('is-valid');
            } else {
              item.classList.add('is-invalid');
            }

            label.className = 'review-field__label';
            label.textContent = field.label;

            if (field.required === true) {
              const req = document.createElement('span');
              req.textContent = '*';
              label.appendChild(req);
            }

            if (!fieldValue) {
              if (field.required === true) {
                fieldValue = 'Missing';
              } else {
                fieldValue = 'Optional / blank';
              }
            }

            if (field.key === 'attachFile' && fieldValue && isFileAttachValid() === true && hasAttachedPdf() !== true) {
              fieldValue = fieldValue + ' (PDF recommended)';
            }

            if (field.key === 'attachFile' && fieldValue && isFileAttachValid() === true && hasAttachedPdf() === true && doesFileNameMatchExpected() !== true) {
              fieldValue = fieldValue + ' (missing quote ID)';
            }

            value.className = 'review-field__value';
            value.textContent = fieldValue;
            status.className = 'review-field__status';

            if (isValid === true) {
              status.textContent = '✓';
            } else {
              status.textContent = '!';
            }

            item.appendChild(label);
            item.appendChild(value);
            item.appendChild(status);
            list.appendChild(item);
          });

          confirmLabel.className = 'review-confirm';

          if (ready === true) {
            confirmLabel.classList.add('is-ready');
          } else {
            confirmLabel.classList.add('is-disabled-visual');
          }

          confirmCheckbox.type = 'checkbox';
          confirmCheckbox.setAttribute('data-review-confirm-checkbox', '');

          if (workflowState.reviewConfirmed === true) {
            confirmCheckbox.checked = true;
          }

          confirmText.textContent = 'I confirm the quote email details are correct.';
          confirmLabel.appendChild(confirmCheckbox);
          confirmLabel.appendChild(confirmText);
          panel.appendChild(title);
          panel.appendChild(list);
          panel.appendChild(confirmLabel);

          if (ready !== true && workflowState.reviewConfirmAttempted === true) {
            confirmMessage.className = 'review-confirm-message';
            confirmMessage.textContent = 'Please fill in all missing/required fields';
            panel.appendChild(confirmMessage);
          }

          return panel;
        }

        function createAttachFilePanel() {
          const attachPanel = document.createElement('div');
          const files = getAttachedFiles();
          const actions = document.createElement('div');
          const attachButton = document.createElement('button');

          attachPanel.className = 'review-panel quote-attach-panel';

          if (files.length > 0) {
            const fileList = document.createElement('ul');
            const message = document.createElement('p');

            fileList.className = 'quote-attach-file-list';

            files.forEach(function (file, index) {
              const item = document.createElement('li');
              const name = document.createElement('span');
              const removeButton = document.createElement('button');
              let fileLabel = normalizeText(file.name || '');

              if (isAttachedFileAllowedSize(file) !== true) {
                fileLabel = fileLabel + ' — over 30MB';
              }

              if (isAttachedFileAllowedType(file) !== true) {
                fileLabel = fileLabel + ' — unsupported type';
              }

              item.className = 'quote-attach-file';

              if (isAttachedFileAllowedSize(file) !== true || isAttachedFileAllowedType(file) !== true) {
                item.classList.add('is-invalid');
              }

              name.className = 'quote-attach-file__name';
              name.textContent = fileLabel;
              removeButton.className = 'quote-attach-file__remove';
              removeButton.type = 'button';
              removeButton.setAttribute('data-remove-attached-file', String(index));
              removeButton.setAttribute('title', 'Remove attached file');
              removeButton.textContent = '×';

              item.appendChild(name);
              item.appendChild(removeButton);
              fileList.appendChild(item);
            });

            attachPanel.appendChild(fileList);

            message.className = 'quote-attach-message';

            if (hasAttachedFileSizeError() === true) {
              message.classList.add('is-error');
              message.textContent = 'Max file size is 30MB.';
              attachPanel.appendChild(message);
            } else if (hasAttachedFileTypeError() === true) {
              message.classList.add('is-error');
              message.textContent = 'Allowed file types: JPG, JPEG, PNG, GIF, and PDF.';
              attachPanel.appendChild(message);
            } else if (hasAttachedPdf() !== true) {
              message.classList.add('is-warning');
              message.textContent = 'No PDF detected. Images are allowed, but the saved cart quote PDF should normally be attached before sending.';
              attachPanel.appendChild(message);
            } else if (doesFileNameMatchExpected() !== true) {
              message.classList.add('is-warning');
              message.textContent = 'PDF attached, but the filename must include "Shopping Cart Quote QT-" plus the quote date/time ID.';
              attachPanel.appendChild(message);
            }
          }

          actions.className = 'quote-attach-panel__actions';

          attachButton.className = 'btn workflow-action'; // workflow-action--primary
          attachButton.type = 'button';
          attachButton.setAttribute('data-attach-pdf-trigger', '');

          if (files.length > 0) {
            const clearButton = document.createElement('button');

            attachButton.textContent = 'Attach / Replace Files';
            actions.appendChild(attachButton);

            if (files.length > 1) {
              clearButton.className = 'workflow-action workflow-action--danger';
              clearButton.type = 'button';
              clearButton.setAttribute('data-clear-attached-files', '');
              clearButton.textContent = 'Clear Attached Files';
              actions.appendChild(clearButton);
            }

            if (isFileAttachValid() === true) {
              const continueButton = document.createElement('button');

              continueButton.className = 'workflow-action workflow-action--primary';
              continueButton.type = 'button';
              continueButton.setAttribute('data-continue-review-with-current-attachment', '');
              continueButton.textContent = 'Continue to Review';

              actions.appendChild(continueButton);
            }
          } else {
            attachButton.textContent = 'Attach Saved Quote PDF';
            actions.appendChild(attachButton);
          }

          attachPanel.appendChild(actions);

          return attachPanel;
        }

        function createSendEmailPanel() {
          const panel = document.createElement('div');

          panel.innerHTML = `
            <div class="review-panel quote-send-panel quote-reset-panel">
              <div class="quote-attach-panel__actions">
                <div class="send-email-svg-frame">                    
                    <button class="workflow-action workflow-action--send button" type="button" data-send-email-button>Send Quote Email</button>
                    <button class="workflow-action workflow-action--danger button reset" type="button" data-start-new-quote-button>Start New Quote</button>        
                    <div class="circle"></div>
                    <div class="circle-outer"></div>        
                    <svg class="icon mail" viewBox="0 0 120 70">
                        <polyline points="119,1 119,69 1,69 1,1"></polyline>
                        <polyline points="119,1 60,45 1,1 119,1"></polyline>
                    </svg>        
                    <svg class="icon plane" viewBox="0 0 120 110">
                        <polyline points="119,1 1,59 106,80 119,1"></polyline>
                        <polyline points="119,1 40,67 43,105 69,73"></polyline>
                    </svg>
                </div>
                
              </div>
            </div>
          `.trim();

          /*
          <input type="checkbox" id="cb">
          <label for="cb" class="button">Send mail</label>
          <label for="cb" class="button reset">Reset</label>
          <button class="workflow-action workflow-action--send" type="button" data-send-email-button>Send Quote Email</button>
          <button class="workflow-action workflow-action--danger" type="button" data-start-new-quote-button>Start New Quote</button>
          */

          const panelEl = panel.firstElementChild;

          updateSendEmailPanelState(panelEl);

          return panelEl;
        }

        function updateSendEmailPanelState(panelEl) {
          const sendPanel = panelEl || document.querySelector('.quote-send-panel');

          if (!sendPanel) {
            return;
          }

          const sendButton = sendPanel.querySelector('[data-send-email-button]');
          const resetButton = sendPanel.querySelector('[data-start-new-quote-button]');

          sendPanel.classList.toggle('is-sending', workflowState.sendQuoteEmail === true && workflowState.emailSent !== true);
          sendPanel.classList.toggle('is-sent', workflowState.emailSent === true);
          sendPanel.classList.toggle('is-error', workflowState.emailError === true);

          if (sendButton) {
            sendButton.hidden = workflowState.sendQuoteEmail === true || workflowState.emailSent === true;
            sendButton.disabled = workflowState.sendQuoteEmail === true || workflowState.emailSent === true;
          }

          if (resetButton) {
            resetButton.hidden = workflowState.emailSent !== true;
          }
        }

        function updateRenderedWorkflowStepStates() {
          const visibleWorkflowSteps = getVisibleWorkflowSteps();
          const completedCount = getCompletedCount();
          const totalCount = visibleWorkflowSteps.length;
          const progress = Math.round((completedCount / totalCount) * 100);
          const nextIndex = getNextIncompleteIndex();
          const modalBarEl = document.querySelector('.preview-section__modal-bar');

          if (modalBarEl) {
            if (workflowState.sendToHelpdesk === true) {
              modalBarEl.setAttribute('data-mode', 'email');
            } else {
              modalBarEl.setAttribute('data-mode', 'quick');
            }

            if (nextIndex === -1) {
              modalBarEl.setAttribute('data-step', 'complete');
            } else {
              modalBarEl.setAttribute('data-step', String(nextIndex));
            }
          }

          const manuallyOpenedStepKey = workflowState.manuallyOpenedStepKey;

          visibleWorkflowSteps.forEach(function (step, index) {
            const item = document.querySelector('.quote-step[data-step-key="' + step.key + '"]');

            if (!item) {
              return;
            }

            const label = item.querySelector('.quote-step__label');
            const hint = item.querySelector('.quote-step__hint');

            item.classList.remove('is-complete');
            item.classList.remove('is-active');
            item.classList.remove('is-error');
            item.classList.remove('is-locked');
            item.classList.remove('is-manually-open');

            if (workflowState.manuallyOpenedStepKey === step.key) {
              item.classList.add('is-manually-open');
            }

            if (isStepComplete(step) === true) {
              item.classList.add('is-complete');
            }

            if (manuallyOpenedStepKey) {
              if (manuallyOpenedStepKey === step.key) {
                item.classList.add('is-active');
              }
            } else if (isStepActive(step) === true) {
              item.classList.add('is-active');
            } else if (index === nextIndex) {
              item.classList.add('is-active');
            }

            if (isStepError(step) === true) {
              item.classList.add('is-error');
            }

            if (index > nextIndex && nextIndex !== -1) {
              item.classList.add('is-locked');
            }

            if (label) {
              label.textContent = getStepLabel(step);
            }

            if (hint) {
              hint.textContent = getStepHint(step);
            }
          });

          progressBarEl.style.width = progress + '%';
          completedCountEl.textContent = String(completedCount);
          totalCountEl.textContent = String(totalCount);

          if (completedCount === totalCount && workflowState.sendToHelpdesk === true) {
            statusEl.textContent = 'Complete';
          } else if (completedCount === totalCount) {
            statusEl.textContent = 'Print flow complete';
          } else if (canSendEmail() === true) {
            statusEl.textContent = 'Ready to send';
          } else {
            statusEl.textContent = 'Next step ready';
          }
        }

        function shakeInvalidReviewFields() {
          const invalidFields = document.querySelectorAll('.review-field.is-invalid');

          invalidFields.forEach(function (field) {
            field.classList.remove('is-shaking');
            field.getBoundingClientRect();
            field.classList.add('is-shaking');
          });
        }

        function showReviewConfirmMessage() {
          const reviewPanel = document.querySelector('.review-panel');

          if (!reviewPanel) {
            return;
          }

          if (reviewPanel.querySelector('.review-confirm-message')) {
            return;
          }

          const confirmLabel = reviewPanel.querySelector('.review-confirm');

          if (!confirmLabel) {
            return;
          }

          const confirmMessage = document.createElement('p');
          confirmMessage.className = 'review-confirm-message';
          confirmMessage.textContent = 'Please fill in all missing/required fields';

          confirmLabel.insertAdjacentElement('afterend', confirmMessage);
        }

        function renderWorkflow() {
          const visibleWorkflowSteps = getVisibleWorkflowSteps();
          const completedCount = getCompletedCount();
          const totalCount = visibleWorkflowSteps.length;
          const progress = Math.round((completedCount / totalCount) * 100);
          const nextIndex = getNextIncompleteIndex();
          const modalBarEl = document.querySelector('.preview-section__modal-bar');

          updatePrintControlInvalidStates(visibleWorkflowSteps, nextIndex);
          collapsePrintControlAccordionsAfterReviewComplete();

          if (modalBarEl) {
            if (workflowState.sendToHelpdesk === true) {
              modalBarEl.setAttribute('data-mode', 'email');
            } else {
              modalBarEl.setAttribute('data-mode', 'quick');
            }

            if (nextIndex === -1) {
              modalBarEl.setAttribute('data-step', 'complete');
            } else {
              modalBarEl.setAttribute('data-step', String(nextIndex));
            }
          }

          listEl.innerHTML = '';

          const manuallyOpenedStepKey = workflowState.manuallyOpenedStepKey;

          visibleWorkflowSteps.forEach(function (step, index) {
            const item = document.createElement('li');
            const icon = document.createElement('span');
            const iconDot = document.createElement('span');
            const body = document.createElement('span');
            const label = document.createElement('span');
            const hint = document.createElement('span');

            item.className = 'quote-step';
            item.setAttribute('data-step-key', step.key);

            if (workflowState.manuallyOpenedStepKey === step.key) {
              item.classList.add('is-manually-open');
            }

            if (isStepComplete(step) === true) {
              item.classList.add('is-complete');
            }

            if (manuallyOpenedStepKey) {
              if (manuallyOpenedStepKey === step.key) {
                item.classList.add('is-active');
              }
            } else if (isStepActive(step) === true) {
              item.classList.add('is-active');
            } else if (index === nextIndex) {
              item.classList.add('is-active');
            }

            if (isStepError(step) === true) {
              item.classList.add('is-error');
            }

            if (index > nextIndex && nextIndex !== -1) {
              item.classList.add('is-locked');
            }

            icon.className = 'quote-step__icon';
            icon.setAttribute('aria-hidden', 'true');
            iconDot.className = 'quote-step__icon-dot';
            icon.appendChild(iconDot);
            body.className = 'quote-step__body';
            label.className = 'quote-step__label';
            label.textContent = getStepLabel(step);
            hint.className = 'quote-step__hint';
            hint.textContent = getStepHint(step);

            body.appendChild(label);
            body.appendChild(hint);

            if (step.key === 'printDialog' && workflowState.sendToHelpdesk === true && (isStepActive(step) === true || workflowState.manuallyOpenedStepKey === 'printDialog')) {
              body.appendChild(createPrintDialogPanel());
            }

            if (step.key === 'fileAttached' && (isStepActive(step) === true || workflowState.fileAttached === true || isFileAttachValid() === true)) {
              body.appendChild(createAttachFilePanel());
            }

            if (step.key === 'sendQuoteEmail' && (isStepActive(step) === true || workflowState.sendQuoteEmail === true || workflowState.emailSent === true)) {
              body.appendChild(createSendEmailPanel());
            }

            if (step.hasReviewPanel === true) {
              body.appendChild(createReviewPanel());
            }

            item.appendChild(icon);

            item.appendChild(body);
            listEl.appendChild(item);
          });

          progressBarEl.style.width = progress + '%';
          completedCountEl.textContent = String(completedCount);
          totalCountEl.textContent = String(totalCount);

          if (completedCount === totalCount && workflowState.sendToHelpdesk === true) {
            statusEl.textContent = 'Complete';
          } else if (completedCount === totalCount) {
            statusEl.textContent = 'Print flow complete';
          } else if (canSendEmail() === true) {
            statusEl.textContent = 'Ready to send';
          } else {
            statusEl.textContent = 'Next step ready';
          }
        }

        function applySendToHelpdeskToggle(sendToHelpdeskToggle) {
          if (!sendToHelpdeskToggle) {
            return;
          }

          workflowState.sendToHelpdesk = sendToHelpdeskToggle.checked === true;

          if (workflowState.sendToHelpdesk === true) {
            setPrintControlsAccordionsCollapsed(true);
          } else {
            setPrintControlsAccordionsCollapsed(false);
          }

          if (workflowState.sendToHelpdesk !== true) {
            workflowState.fileAttached = false;
            workflowState.fileNameMatches = false;
            workflowState.reviewConfirmed = false;
            workflowState.reviewConfirmAttempted = false;
            workflowState.printControlAccordionsCollapsedAfterReview = false;
            workflowState.sendQuoteEmail = false;
            workflowState.emailSent = false;
            workflowState.emailError = false;
          }

          renderWorkflow();
        }

        document.addEventListener('click', function (event) {
          const sendToHelpdeskToggleLabel = event.target.closest('label.quote-workflow__helpdesk-toggle');

          if (!sendToHelpdeskToggleLabel) {
            return;
          }

          const sendToHelpdeskToggle = sendToHelpdeskToggleLabel.querySelector('[data-send-to-helpdesk-toggle]');

          if (!sendToHelpdeskToggle) {
            return;
          }

          window.setTimeout(function () {
            applySendToHelpdeskToggle(sendToHelpdeskToggle);
          }, 0);
        });

        document.addEventListener('change', function (event) {
          const sendToHelpdeskToggle = event.target.closest('[data-send-to-helpdesk-toggle]');

          if (sendToHelpdeskToggle) {
            applySendToHelpdeskToggle(sendToHelpdeskToggle);
            return;
          }

          const checkbox = event.target.closest('[data-review-confirm-checkbox]');

          if (!checkbox) {
            return;
          }

          if (isReviewReady() !== true) {
            workflowState.reviewConfirmed = false;
            workflowState.reviewConfirmAttempted = true;
            checkbox.checked = false;
            showReviewConfirmMessage();
            shakeInvalidReviewFields();
            openInvalidPrintControlAccordions();
            return;
          }

          workflowState.reviewConfirmAttempted = false;
          workflowState.reviewConfirmed = checkbox.checked === true;

          if (workflowState.reviewConfirmed !== true) {
            workflowState.printControlAccordionsCollapsedAfterReview = false;
          }

          renderWorkflow();
        });

        document.addEventListener('click', function (event) {
          const reviewFieldEl = event.target.closest('.review-field-list .review-field');

          if (!reviewFieldEl) {
            return;
          }

          const fieldKey = reviewFieldEl.getAttribute('data-review-field-key');

          if (!fieldKey) {
            return;
          }

          event.preventDefault();
          focusReviewFieldTarget(fieldKey);
        });

        document.addEventListener('keydown', function (event) {
          const reviewFieldEl = event.target.closest('.review-field-list .review-field');

          if (!reviewFieldEl) {
            return;
          }

          if (event.key !== 'Enter' && event.key !== ' ') {
            return;
          }

          const fieldKey = reviewFieldEl.getAttribute('data-review-field-key');

          if (!fieldKey) {
            return;
          }

          event.preventDefault();
          focusReviewFieldTarget(fieldKey);
        });

        document.addEventListener('input', function (event) {
          if (event.target.closest('.print-controls')) {
            syncEmailFormFields(true);
            updateRenderedWorkflowStepStates();
            return;
          }
        });

        window.addEventListener('beforeprint', function () {
          markPrintAttempted();
        });

        document.addEventListener('change', function (event) {
          const fileInput = event.target.closest(FORM_SELECTORS.attachFileInput);

          if (!fileInput) {
            return;
          }

          resetWorkflowAfterAttachedFilesChange();
          renderWorkflow();
        });

        document.addEventListener('click', function (event) {
          const attachBtn = event.target.closest('[data-attach-pdf-trigger]');
          if (!attachBtn) {
            return;
          }
          event.preventDefault();
          if (!document.body.classList.contains('demo')) {
            const globoButton = document.querySelector(FORM_SELECTORS.attachFileButtonTrigger);
            if (globoButton) {
              globoButton.click();
              return;
            }
          }
          const fileInput = document.querySelector(FORM_SELECTORS.attachFileInput);
          if (fileInput) {
            fileInput.click();
          }
        });

        document.addEventListener('click', function (event) {
          const removeButton = event.target.closest('[data-remove-attached-file]');

          if (!removeButton) {
            return;
          }

          event.preventDefault();

          const removeIndex = Number(removeButton.getAttribute('data-remove-attached-file'));

          if (Number.isNaN(removeIndex)) {
            return;
          }

          removeAttachedFileAtIndex(removeIndex);
        });

        document.addEventListener('click', function (event) {
          const proceedButton = event.target.closest('[data-proceed-print-to-attach]');

          if (!proceedButton) {
            return;
          }

          event.preventDefault();
          continueFromPrintToAttach();
        });


        document.addEventListener('click', function (event) {
          const continueButton = event.target.closest('[data-continue-review-with-current-attachment]');

          if (!continueButton) {
            return;
          }

          event.preventDefault();
          continueToReviewWithCurrentAttachedFiles();
        });

        document.addEventListener('click', function (event) {
          const completedWorkflowStep = event.target.closest('[data-step-key="printDialog"].is-complete, [data-step-key="fileAttached"].is-complete');

          if (!completedWorkflowStep) {
            return;
          }

          if (event.target.closest('.quote-print-panel, .quote-attach-panel')) {
            return;
          }

          event.preventDefault();

          const stepKey = completedWorkflowStep.getAttribute('data-step-key') || '';

          if (workflowState.manuallyOpenedStepKey === stepKey) {
            workflowState.manuallyOpenedStepKey = '';
          } else {
            workflowState.manuallyOpenedStepKey = stepKey;
          }

          renderWorkflow();
        });

        document.addEventListener('click', function (event) {
          const sendBtn = event.target.closest('[data-send-email-button]');
          if (!sendBtn) {
            return;
          }

          event.preventDefault();
          submitEmail();
        });

        document.addEventListener('click', function (event) {
          const startNewQuoteBtn = event.target.closest('[data-start-new-quote-button]');

          if (!startNewQuoteBtn) {
            return;
          }

          event.preventDefault();
          resetWorkflowStateForNewQuote();
        });

        // init in bottom of js

        /* END- EMAIL DASHBOARD PROTOTYPE INTEGRATION*/
        ///////////////////////////////////////////////////////////////
        ////////////////////////////////////////////////////////////////

        ///////////////////////////////////////////////////////////////
        ////////////////////////////////////////////////////////////////
        /* START - PRIMARY - CART QUOTE PREVIEW MODAL */

        if (document.querySelector('html.pl')) {
          activeStore = 'pl';
        } else if (document.querySelector('html.ofc')) {
          activeStore = 'ofc';
        } else if (document.querySelector('html.ot')) {
          activeStore = 'ot';
        }

        //document.querySelector(".pp-customer-rep-name").value = "";
        //document.querySelector(".pp-customer-rep-email").value = "";
        document.querySelector('.pp-customer-name').value = '';
        document.querySelector('.pp-customer-email').value = '';
        document.querySelector('.pp-customer-phone').value = '';
        document.querySelector('.pp-notes').value = '';

        function getCartRoot() {
          const direct = document.querySelector('#cartItems');

          if (direct) {
            return direct;
          }

          return document.querySelector('#cart-items');
        }

        function isValidEmail(value) {
          return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
        }

        function canPrint() {
          const emailEls = [document.querySelector('#pp-customer-rep-email'), document.querySelector('#pp-customer-email')].filter(Boolean);

          return emailEls.every(function (emailEl) {
            const value = emailEl.value.trim();

            return !value || isValidEmail(value);
          });
        }

        function normalizeText(value) {
          let text = '';
          if (typeof value === 'string') {
            text = value;
          }
          text = text.replace(/\s+/g, ' ').trim();
          return text;
        }

        function getTextContent(el) {
          if (!el) {
            return '';
          }
          return normalizeText(el.textContent || '');
        }

        function getPriceTextContent(el) {
          if (!el) {
            return '';
          }

          const rawText = normalizeText(el.textContent || '');
          const hasUsd = /\bUSD\b/i.test(rawText);
          const currencySuffix = hasUsd ? ' USD' : '';

          const supEl = el.querySelector('sup');

          if (!supEl) {
            return rawText.replace(/\s+USD$/i, '') + currencySuffix;
          }

          const cents = normalizeText(supEl.textContent || '').replace(/\D/g, '');
          let dollars = '';

          el.childNodes.forEach(function (node) {
            if (node === supEl) {
              return;
            }

            dollars += node.textContent || '';
          });

          dollars = normalizeText(dollars).replace(/\s+USD$/i, '');

          if (!dollars) {
            return rawText.replace(/\s+USD$/i, '') + currencySuffix;
          }

          if (!cents) {
            return dollars + currencySuffix;
          }

          return dollars + '.' + cents + currencySuffix;
        }

        function normalizeHTML(value) {
          let html = '';
          if (typeof value === 'string') {
            html = value;
          }
          // remove excessive whitespace between tags only
          html = html.replace(/>\s+</g, '><').trim();
          return html;
        }

        function getInnerHTML(el) {
          if (!el) {
            return '';
          }
          return normalizeHTML(el.innerHTML || '');
        }

        function extractRowPrices(row) {
          const unitPriceEl = row.querySelector('.cart-item__info .price__current');
          const lineTotalEl = row.querySelector('.cart-item__total.price .price__current');

          let unitPrice = '';
          let lineTotal = '';

          if (unitPriceEl) {
            unitPrice = getPriceTextContent(unitPriceEl);
          }

          if (lineTotalEl) {
            lineTotal = getPriceTextContent(lineTotalEl);
          }

          return { unitPrice: unitPrice, lineTotal: lineTotal };
        }

        function extractQuantity(row) {
          const qtyInput = row.querySelector('quantity-input .qty-input--combined .qty-input__input');

          if (qtyInput) {
            return normalizeText(qtyInput.value || qtyInput.getAttribute('value') || '');
          }

          const qtyBold = row.querySelector('.cart-item__qty b');

          if (qtyBold) {
            return getTextContent(qtyBold);
          }

          return '';
        }

        function extractVendor(row) {
          const vendorEl = row.querySelector('.cart-item__details > div:first-child');

          if (vendorEl) {
            return getTextContent(vendorEl);
          }

          return '';
        }

        function extractImage(row) {
          const imageEl = row.querySelector('.cart-item__image a img');

          if (!imageEl) {
            return { src: '', alt: '' };
          }

          let src = imageEl.getAttribute('src') || '';

          if (src.indexOf('//') === 0) {
            src = window.location.protocol + src;
          }

          return { src: src, alt: imageEl.getAttribute('alt') || '' };
        }

        function collectOptions(row) {
          const options = [];
          const optionEls = row.querySelectorAll('.cart-custom-options .product-option');

          optionEls.forEach(function (optionEl) {
            const dt = optionEl.querySelector('dt');
            const dd = optionEl.querySelector('dd');
            const label = getTextContent(dt);
            let value = getTextContent(dd);

            const cleanLabel = label.replace(/:$/, '').trim();
            if (cleanLabel == 'Share Link') {// label
              value = getInnerHTML(dd);
            }

            if (label && value) {
              options.push({ label: label, value: value });
            }
          });

          return options;
        }

        function extractSku(options) {
          for (let i = 0; i < options.length; i += 1) {
            const row = options[i];
            const label = row.label.toLowerCase();

            if (label.indexOf('sku') !== -1) {
              return row.value;
            }
          }

          return '';
        }

        function collectCartData() {
          const cartRoot = getCartRoot();
          const summaryRoot = document.querySelector('#cart-summary');
          const rows = cartRoot ? cartRoot.querySelectorAll('.cart-item') : [];
          const items = [];

          rows.forEach(function (row) {
            const titleEl = row.querySelector('.cart-item__title');
            const prices = extractRowPrices(row);
            const options = collectOptions(row);
            const image = extractImage(row);
            const qty = extractQuantity(row);
            const vendor = extractVendor(row);
            //const sku = extractSku(options);

            let cartItemInfoEl = row.querySelector('.cart-item__info');
            let cartItemPriceEl = row.querySelector('.cart-item__price');

            let priceColorClass = '';
            if (row.querySelector('td.cart-item__total.price--sale-color')) {
              priceColorClass = 'price--sale-color';
            }

            items.push({
              vendor: vendor,
              title: getTextContent(titleEl),
              titleHref: titleEl ? titleEl.getAttribute('href') || '' : '',
              imageSrc: image.src,
              imageAlt: image.alt,
              qty: qty,
              unitPrice: normalizeText(prices.unitPrice),
              lineTotal: normalizeText(prices.lineTotal),
              // This spreads the property into the object ONLY if priceWasEl exists (conditional check)
              ...(cartItemInfoEl && { cartItemInfoHTML: cartItemInfoEl.innerHTML }),
              ...(cartItemPriceEl && { cartItemPriceHTML: cartItemPriceEl.innerHTML }),
              priceSaleColorClass: priceColorClass,
              //...(discountLabelsEl && { discountLabelsHTML: discountLabelsEl.innerHTML }),
              //sku: sku,
              options: options,
            });
          });

          let subtotalLabel = '';
          let subtotalValue = '';
          let discountLabel = '';
          let discountValue = '';

          if (summaryRoot) {
            const discountLabelEl = summaryRoot.querySelector('.cart-total-discount > div:first-child');
            const discountValueEl = summaryRoot.querySelector('.cart-total-discount > div:last-child');
            const labelEl = summaryRoot.querySelector('div.flex.justify-between.items-center > p:first-child') || summaryRoot.querySelector('div > p:first-child');
            const valueEl = summaryRoot.querySelector('div.flex.justify-between.items-center > p:last-child') || summaryRoot.querySelector('div > p:last-child');

            if (discountLabelEl) {
              discountLabel = getTextContent(discountLabelEl);
            }

            if (discountValueEl) {
              discountValue = getPriceTextContent(discountValueEl);
            }

            if (labelEl) {
              subtotalLabel = getTextContent(labelEl);
            }

            if (valueEl) {
              subtotalValue = getPriceTextContent(valueEl);
            }
          }

          return {
            items: items,
            discountLabel: discountLabel,
            discountValue: discountValue,
            subtotalLabel: subtotalLabel,
            subtotalValue: subtotalValue,
          };
        }

        function buildPreparedForText() {
          const nameEl = document.querySelector('.pp-customer-name');
          const emailEl = document.querySelector('.pp-customer-email');
          const phoneEl = document.querySelector('.pp-customer-phone');
          const name = nameEl ? normalizeText(nameEl.value || '') : '';
          const email = emailEl ? normalizeText(emailEl.value || '') : '';
          const phone = phoneEl ? normalizeText(phoneEl.value || '') : '';
          const lines = [];

          if (name) {
            lines.push('<b>Customer Name:</b> ' + '<span class="pp-customer-name-value">' + name + '</span>');
          } else if (!name) {
            //lines.push('<b>Customer Name:</b> ');
          }

          if (email) {
            lines.push('<b>Customer Email:</b> ' + '<span class="pp-customer-email-value">' + email + '</span>');
          } else if (!email) {
            //lines.push('<b>Customer Email:</b> customer@email.com');
          }

          if (phone) {
            lines.push('<b>Customer Phone:</b> ' + '<span class=""pp-customer-phone-value">' + phone + '</span>');
          } else if (!phone) {
            //lines.push('<b>Customer Phone:</b> ');
          }

          return lines.join('\n');
        }

        function buildNotesText() {
          const notesEl = document.querySelector('.pp-notes');
          const notes = notesEl ? String(notesEl.value || '').trim() : '';

          if (notes) {
            return notes;
          }

          return ''; //'Please add your customer notes of rthis customer cart page quote.';//'This print layout is generated separately from the live cart markup so you can keep the browser cart interactive while printing a clean quote-style page.';
        }

        function formatPhoneInput(value) {
          let raw = String(value || '').trim();

          if (!raw) {
            return '';
          }

          if (raw.charAt(0) === '+') {
            raw = '+' + raw.substring(1).replace(/[^\d]/g, '');
            return raw;
          }

          const digits = raw.replace(/\D/g, '');

          if (digits.length <= 3) {
            return digits;
          }

          if (digits.length <= 6) {
            return '(' + digits.substring(0, 3) + ') ' + digits.substring(3);
          }

          if (digits.length <= 10) {
            return '(' + digits.substring(0, 3) + ') ' + digits.substring(3, 6) + '-' + digits.substring(6);
          }

          if (digits.length === 11 && digits.charAt(0) === '1') {
            return '+1 (' + digits.substring(1, 4) + ') ' + digits.substring(4, 7) + '-' + digits.substring(7);
          }

          return digits;
        }

        function bindPhoneInputFormatting() {
          const phoneEl = document.querySelector('#pp-customer-phone');

          if (!phoneEl) {
            return;
          }

          phoneEl.addEventListener('blur', function () {
            phoneEl.value = formatPhoneInput(phoneEl.value);
            renderPrettyPrintPreview();
          });

          phoneEl.addEventListener('input', function () {
            const start = phoneEl.selectionStart;
            const before = phoneEl.value;
            const formatted = formatPhoneInput(before);
            phoneEl.value = formatted;
            if (start !== null) {
              const diff = formatted.length - before.length;
              phoneEl.setSelectionRange(start + diff, start + diff);
            }
            renderPrettyPrintPreview();
          });
        }

        function bindEmailValidation(emailEl) {
          if (!emailEl) {
            return;
          }

          emailEl.addEventListener('input', function () {
            const value = emailEl.value.trim();

            if (!value) {
              emailEl.classList.remove('is-valid', 'is-invalid');
              updateRenderedWorkflowStepStates();
              return;
            }

            if (isValidEmail(value)) {
              emailEl.classList.add('is-valid');
              emailEl.classList.remove('is-invalid');
            } else {
              emailEl.classList.add('is-invalid');
              emailEl.classList.remove('is-valid');
            }

            updateRenderedWorkflowStepStates();
          });
        }

        function buildQuoteId(forceNew) {
          if (CURRENT_QUOTE_ID && !forceNew) {
            return CURRENT_QUOTE_ID;
          }

          const now = new Date();
          const yyyy = now.getFullYear();
          const mm = String(now.getMonth() + 1).padStart(2, '0');
          const dd = String(now.getDate()).padStart(2, '0');
          const hh = String(now.getHours()).padStart(2, '0');
          const min = String(now.getMinutes()).padStart(2, '0');
          const ss = String(now.getSeconds()).padStart(2, '0');
          // --- Get customer name ---
          const nameEl = document.querySelector('#pp-customer-name');
          let initials = '';

          if (nameEl) {
            const raw = String(nameEl.value || '').trim();
            if (raw) {
              const parts = raw.split(/\s+/);
              if (parts.length === 1) {
                // single word → first 2 chars
                initials = parts[0].substring(0, 2).toUpperCase();
              }
              if (parts.length > 1) {
                // multi word → first + last
                const first = parts[0].charAt(0);
                const last = parts[parts.length - 1].charAt(0);
                initials = (first + last).toUpperCase();
              }
            }
          }

          // fallback if no name
          if (!initials) {
            initials = 'NA';
          }

          CURRENT_QUOTE_ID = 'QT-' + yyyy + mm + dd + '-' + hh + min + ss + '-' + initials;

          return CURRENT_QUOTE_ID;
        }

        function buildQuoteDate() {
          const now = new Date();

          return now.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
        }

        function csrAddress(store) {
          var info = [
            { store: 'pl', numberLocal: '727.498.0547', numberTollFree: '1.866.516.0934' },
            { store: 'ofc', numberLocal: '727.597.4134', numberTollFree: '1.866.712.5684' },
            { store: 'ot', numberLocal: '727.597.4141', numberTollFree: '1.866.516.0941' },
          ];

          // find matching store object
          let storeData = info.find((obj) => obj.store === store);

          if (storeData) {
            return { numberLocal: storeData.numberLocal, numberTollFree: storeData.numberTollFree };
          }
        }

        function createOptionRows(options) {
          const fragment = document.createDocumentFragment();
          options.forEach(function (option) {
            const row = document.createElement('div');
            row.className = 'quote-item-options-row';

            const label = document.createElement('span');
            label.className = 'quote-item-options-label';
            label.textContent = option.label + ' ';

            let value = document.createElement('span');
            const cleanLabel = option.label.replace(/:$/, '').trim();
            if (cleanLabel == 'Share Link') {//option.label
              if (showShareLinkAsUrl == true) {
                var myAnchorString = option.value;
                var newAnchorString = myAnchorString.replace(/(<a[^>]*href=["'])([^"']+)(["'][^>]*>)([\s\S]*?)(<\/a>)/i, function (match, p1, href, p3, text, p5) {
                  return p1 + href + p3 + href + p5;
                });
                value.innerHTML = newAnchorString;
              } else {
                value.innerHTML = option.value;
              }
            } else {
              value.textContent = option.value;
            }

            row.appendChild(label);
            row.appendChild(value);
            fragment.appendChild(row);
          });

          return fragment;
        }

        function createQuoteItemRow(item) {
          //console.debug("item", item);

          const tr = document.createElement('tr');
          tr.className = 'quote-item-row';

          const itemTd = document.createElement('td');
          const qtyTd = document.createElement('td');
          const unitTd = document.createElement('td');
          const totalTd = document.createElement('td');

          let priceSaleColorClass = '';
          if (item.priceSaleColorClass == '') {
            priceSaleColorClass = item.priceSaleColorClass;
          }

          qtyTd.className = 'quote-qty-cell';
          unitTd.className = 'quote-price-cell';
          totalTd.className = 'quote-price-cell ' + item.priceSaleColorClass;

          const itemCell = document.createElement('div');
          itemCell.className = 'quote-item-cell';

          const img = document.createElement('img');
          img.className = 'quote-item-image';
          img.src = item.imageSrc || 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
          img.alt = item.imageAlt || item.title || 'Cart item';

          const textWrap = document.createElement('div');
          textWrap.className = 'quote-item-text-wrap';

          const vendor = document.createElement('div');
          vendor.className = 'quote-item-vendor';
          vendor.textContent = item.vendor || '';

          const title = document.createElement('div');
          title.className = 'quote-item-title';
          title.textContent = item.title || 'Untitled item';

          //const sku = document.createElement('div');
          //sku.className = 'quote-item-sku';

          //if (item.sku) {
          //sku.textContent = 'SKU: ' + item.sku;
          //}

          const cartItemInfoWrap = document.createElement('div');
          cartItemInfoWrap.className = 'cart-item__info';
          cartItemInfoWrap.innerHTML = item.cartItemInfoHTML;

          const optionsWrap = document.createElement('div');
          optionsWrap.className = 'quote-item-options';
          optionsWrap.appendChild(createOptionRows(item.options || []));

          if (item.vendor) {
            textWrap.appendChild(vendor);
          }

          textWrap.appendChild(title);

          //if (item.sku) {
          //textWrap.appendChild(sku);
          //}

          if (item.cartItemInfoHTML && item.cartItemInfoHTML.length) {
            textWrap.appendChild(cartItemInfoWrap);
          }          

          itemCell.appendChild(img);
          itemCell.appendChild(textWrap);
          itemTd.appendChild(itemCell);

          const modalBarEl = document.querySelector('.preview-section__modal-bar');
          if (modalBarEl && modalBarEl.getAttribute('data-force-page-break') === 'true') {
            cartOptionsPosition = 'inside';
          } else if(modalBarEl && modalBarEl.getAttribute('data-force-page-break') === 'false'){
            cartOptionsPosition = 'below';
          }
          
          if (item.options && item.options.length) {
            if(cartOptionsPosition == 'below'){
              itemCell.appendChild(optionsWrap);
            } else if(cartOptionsPosition == 'inside'){
              textWrap.appendChild(optionsWrap);
            }            
          }

          qtyTd.textContent = item.qty || '';
          unitTd.textContent = item.unitPrice || '';

          const cartItemPriceWrap = document.createElement('div');
          cartItemPriceWrap.className = 'cart-item__price';
          cartItemPriceWrap.innerHTML = item.cartItemPriceHTML;

          if (item.cartItemPriceHTML && item.cartItemPriceHTML.length) {
            totalTd.appendChild(cartItemPriceWrap);
          } else {
            totalTd.textContent = item.lineTotal || '';
          }

          tr.appendChild(itemTd);
          tr.appendChild(qtyTd);
          //tr.appendChild(unitTd);
          tr.appendChild(totalTd);

          return tr;
        }

        function buildPrettyPrintQuote(data) {
          const template = document.getElementById('quote-template');
          const node = template.content.firstElementChild.cloneNode(true);
          const itemsTbody = node.querySelector('[data-quote-items]');
          const preparedFor = node.querySelector('[data-prepared-for]');
          const notes = node.querySelector('[data-quote-notes]');
          const discount = node.querySelector('[data-discount]');
          const subtotal = node.querySelector('[data-subtotal]');
          const quoteId = node.querySelector('[data-quote-id]');
          const quoteDate = node.querySelector('[data-quote-date]');
          const quoteCustomerRep = node.querySelector('[data-quote-customer-rep]');
          const quoteBrand = node.querySelector('.quote-brand');
          const quotePhoneLocal = node.querySelector('[data-quote-company-phone-local]');
          const quotePhoneTollFree = node.querySelector('[data-quote-company-phone-toll-free]');

          const customerRepNameEl = document.querySelector('.pp-customer-rep-name');
          const customerRepName = customerRepNameEl ? normalizeText(customerRepNameEl.value || '') : '';

          const logoImgSrc = document.querySelector('.header__logo .logo__link img').src;
          //console.log(logoImgSrc);

          const img = document.createElement('img');
          img.id = 'quote-logo-img';
          img.className = 'quote-logo-image';
          img.src = logoImgSrc;
          img.width = '300';
          img.height = '91';
          img.loading = 'eager';
          quoteBrand.appendChild(img);

          let csrAddressObj = csrAddress(activeStore); // active store

          const aPhoneLocal = document.createElement('a');
          aPhoneLocal.href = 'tel:' + csrAddressObj.numberLocal.replace('.', '');
          aPhoneLocal.textContent = csrAddressObj.numberLocal;
          quotePhoneLocal.appendChild(aPhoneLocal);

          const aPhoneTollFree = document.createElement('a');
          aPhoneTollFree.href = 'tel:' + csrAddressObj.numberTollFree.replace('.', '');
          aPhoneTollFree.textContent = csrAddressObj.numberTollFree;
          quotePhoneTollFree.appendChild(aPhoneTollFree);

          // data-quote-company-phone-local <a href="tel:7274980547">727.498.0547</a>
          // data-quote-company-phone-toll-free <a href="tel:8665160934">1.866.516.0934</a>

          quoteId.textContent = buildQuoteId(false);
          quoteDate.textContent = buildQuoteDate();
          quoteCustomerRep.textContent = customerRepName;
          if (buildPreparedForText() != '') {
            preparedFor.parentElement.classList.add('has-value');
          } else {
            preparedFor.parentElement.classList.remove('has-value');
          }
          preparedFor.innerHTML = buildPreparedForText();
          if (buildNotesText() != '') {
            notes.parentElement.classList.add('has-value');
          } else {
            notes.parentElement.classList.remove('has-value');
          }
          notes.textContent = buildNotesText();
          discount.textContent = data.discountValue || '';
          subtotal.textContent = data.subtotalValue || '';

          data.items.forEach(function (item) {
            itemsTbody.appendChild(createQuoteItemRow(item));
          });

          return node;
        }

        function renderPrettyPrintPreview() {
          const previewRoot = document.getElementById('pretty-print-preview');
          const data = collectCartData();
          const quote = buildPrettyPrintQuote(data);

          previewRoot.innerHTML = '';
          previewRoot.appendChild(quote);
        }

        const PRETTY_PRINT_HIDE_SELECTORS = [
          /* '.shopify-section.shopify-section-group-header-group',
        '.shopify-section.shopify-section-group-header-group.cc-custom-liquid',
        '.shopify-section.shopify-section-group-header-group.cc-announcement',
        '.shopify-section.shopify-section-group-header-group.cc-header',
        '.cart-layout',
        '.page-title',
        '.cart__shipping-calculator.panel',
        '.cart-page-recommendations',
        '.shopify-section.shopify-section-group-footer-group.cc-footer',
        'html body > div:has(> iframe)',
        'html body > div:has(> .needsclick)',
        '.print-controls' */
        ];

        function setPrettyPrintHideState(isHidden) {
          if (PRETTY_PRINT_HIDE_SELECTORS.length > 0) {
            PRETTY_PRINT_HIDE_SELECTORS.forEach(function (selector) {
              const nodes = document.querySelectorAll(selector);

              nodes.forEach(function (node) {
                if (isHidden) {
                  node.classList.add('pp-force-hide');
                } else {
                  node.classList.remove('pp-force-hide');
                }
              });
            });
          }
        }

        let workflowSessionStarted = false;

        function openPrettyPrintModal() {
          CURRENT_QUOTE_ID = '';
          renderPrettyPrintPreview();
          document.documentElement.classList.add('cart-print-modal-active');

          if (workflowSessionStarted !== true) {
            workflowSessionStarted = true;
            resetWorkflowStateForNewQuote();
          }

          workflowState.previewOpened = true;
          workflowState.printDialogOpened = true;
          renderWorkflow();
        }

        function closePrettyPrintModal() {
          document.documentElement.classList.remove('cart-print-modal-active');
        }

        function buildSavedFileName() {
          let customerNameValue = '';

          const now = new Date();
          const formattedDate = `${now.getMonth() + 1}.${now.getDate()}.${now.getFullYear().toString().slice(-2)}`;
          const customerName = document.querySelector('#pp-customer-name');

          if (customerName) {
            customerNameValue = normalizeText(customerName.value || '');
            customerNameValue = customerNameValue.replace(/(^\w|\s\w)/g, (m) => m.toUpperCase());
          }

          CURRENT_QUOTE_ID = '';
          const quoteId = buildQuoteId(true);

          if (customerNameValue) {
            savedFileName = customerNameValue + ' (' + formattedDate + ') Shopping Cart Quote ' + quoteId;
          } else {
            savedFileName = '(' + formattedDate + ') Shopping Cart Quote ' + quoteId;
          }

          return savedFileName;
        }

        function copyQuoteFileName() {
          const fileName = buildSavedFileName();

          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard
              .writeText(fileName)
              .then(function () {
                window.alert('Quote filename copied:\n' + fileName);
              })
              .catch(function () {
                window.prompt('Copy Quote Filename:', fileName);
              });

            return;
          }

          window.prompt('Copy Quote Filename:', fileName);
        }

        function setDynamicOnePagePrintSize() {

          const quoteSheet = document.querySelector('#printable-quote-sheet');
          const modalBarEl = document.querySelector('.preview-section__modal-bar');
          let styleEl = document.querySelector('#dynamic-one-page-print-size');

          if (modalBarEl && modalBarEl.getAttribute('data-force-page-break') === 'true') {
            if (styleEl) {
              styleEl.remove();
            }
            return;
          }

          if (!quoteSheet) {
            return;
          }

          const pageWidthInches = 8.5;
          const marginCm = 0.3;
          const marginInches = marginCm / 2.54;
          const verticalMarginsInches = marginInches * 2;
          const safetyBufferInches = 0.25;

          const contentHeightPx = quoteSheet.scrollHeight;
          const contentHeightInches = contentHeightPx / 96;
          const pageHeightInches = contentHeightInches + verticalMarginsInches + safetyBufferInches;

          if (!styleEl) {
            styleEl = document.createElement('style');
            styleEl.id = 'dynamic-one-page-print-size';
            document.head.appendChild(styleEl);
          }

          styleEl.textContent = `
            @media print {
              @page {
                size: ${pageWidthInches}in ${pageHeightInches.toFixed(2)}in !important;
                margin: ${marginCm}cm !important;
              }
            }
          `;
        }

        function openPrettyPrintWindow() {
          buildSavedFileName();
          renderPrettyPrintPreview();

          //console.log('savedFileName', savedFileName);

          // Auto copy to clipboard
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(savedFileName).catch(function () {
              // silent fail (Firefox permissions, etc.)
            });
          }

          document.documentElement.classList.add('is-print-quote');
          setPrettyPrintHideState(true);
          ORIGINAL_DOC_TITLE = document.title; // Save current title
          document.title = savedFileName;
          setDynamicOnePagePrintSize();
          window.print(); // Opens dialog with newName.pdf
          //document.title = originalTitle; // Restore title after dialog closes
        }

        /* document.querySelector('.rebuild-pretty-print').addEventListener('click', function () {
        renderPrettyPrintPreview();
      }); */

        document.addEventListener('click', function (event) {
          
          // trigger open print preview modal button
          const openModal = event.target.closest('#open-print-preview-modal');
          if (openModal) {
            event.preventDefault();
            openPrettyPrintModal();
            return;
          }

          // trigger close print preview modal button
          const closeModal = event.target.closest('#close-print-preview-modal');
          if (closeModal) {
            closePrettyPrintModal();
            return;
          }

          const forcePrintPageBreak = event.target.closest('.force-break-print-preview');
          if (forcePrintPageBreak) {
            const modalBarEl = document.querySelector('.preview-section__modal-bar');
            if (modalBarEl && modalBarEl.getAttribute('data-force-page-break') === 'true') {
              modalBarEl.setAttribute('data-force-page-break', 'false');
            } else if (modalBarEl && modalBarEl.getAttribute('data-force-page-break') === 'false'){
              modalBarEl.setAttribute('data-force-page-break', 'true');
            }
            renderPrettyPrintPreview();
            return;
          }

          // trigger open browser print preview button
          const openPrint = event.target.closest('.open-print-preview');
          if (openPrint) {
            event.preventDefault();
            event.stopPropagation();

            if (!canPrint()) {
              alert('Please enter a valid email before printing.');
              return;
            }
            //document.documentElement.classList.add('use-pretty-print');
            logPrintPreviewOpened(); // from protype
            renderPrettyPrintPreview();
            openPrettyPrintWindow();
            return;
          }

          // trigger copy quote filename button
          /* const copyBtn = event.target.closest('#copy-quote-filename');
          if (copyBtn) {
            copyQuoteFileName();
            return;
          } */
        });

        const livePreviewFieldIds = [
          '.pp-customer-name', 
          '.pp-customer-email', 
          '.pp-customer-phone', 
          '.pp-notes', 
          '.pp-customer-rep-name', 
          '.pp-customer-rep-email'
        ];

        livePreviewFieldIds.forEach(function (fieldId) {
          const fieldEl = document.querySelector(fieldId);

          if (!fieldEl) {
            return;
          }

          fieldEl.addEventListener('input', function () {
            renderPrettyPrintPreview();
            syncEmailFormFields(true);
            updateSinglePrintControlInvalidState(fieldEl);
            updateRenderedWorkflowStepStates();
          });

          fieldEl.addEventListener('change', function () {
            syncEmailFormFields(true);
            updateSinglePrintControlInvalidState(fieldEl);
            updateRenderedWorkflowStepStates();
          });
        });

        window.addEventListener('beforeprint', function () {
          document.documentElement.classList.add('is-print-quote');
          //document.documentElement.classList.add('use-pretty-print');
        });

        window.addEventListener('afterprint', function () {
          document.title = ORIGINAL_DOC_TITLE;
          document.documentElement.classList.remove('is-print-quote');
          //document.documentElement.classList.remove('use-pretty-print');
          setPrettyPrintHideState(false);
        });

        document.addEventListener('keydown', function (event) {
          if (event.key === 'Escape' && document.documentElement.classList.contains('cart-print-modal-active')) {
            closePrettyPrintModal();
          }
        });

        function insertPrintControls() {
          const target = document.querySelector('html.is-cart h1.cart__title');/* 'html.is-cart form#cart' */
          if (!target) {
            return;
          }
          // prevent duplicate insert
          if (target.querySelector('#open-print-preview-modal')) {
            return;
          }
          const wrapper = document.createElement('div');
          wrapper.className = 'print-controls print-controls-button';
          const link = document.createElement('a');
          link.id = 'open-print-preview-modal';
          link.className = 'btn workflow-action'; //btn--primary
          link.href = '#pretty-print-preview';
          link.setAttribute('rel', 'nofollow');
          link.textContent = 'Open Pretty Print Preview';
          if(document.querySelector('#cart-items .cart-empty')){
            /* temp for testing */
            link.style.display = 'none';
            /* temp for testing */
          }
          wrapper.appendChild(link);
          // append INSIDE h1
          target.appendChild(wrapper);
          // insert BEFORE form#cart
          //target.before(wrapper);
        }

        // init
        document.addEventListener('DOMContentLoaded', () => {
          waitForElementExists('html.is-csr #cart-items tbody .cart-item', true).then((elm) => {
            //document.querySelector('html').classList.add('use-pretty-print');
            renderPrettyPrintPreview();
            bindPhoneInputFormatting();
            bindEmailValidation(document.querySelector('#pp-customer-rep-email'));
            bindEmailValidation(document.querySelector('#pp-customer-email'));

            // init email dashboard
            resetWorkflowStateForNewQuote();
            installEmailSuccessMessageObserver();
            installPowerfulFormAjaxSuccessDetector();
            renderWorkflow();

            // insert print controls in h1
            //setTimeout(function(){
              insertPrintControls();
            //},2000);

            //jonnyZoom('.html-test', { }, 'gallery');
            console.log('is-csr class exists');
          });
        });

        /* END - PRIMARY - CART QUOTE PREVIEW MODAL */
        ///////////////////////////////////////////////////////
      })();